import findResourceInCourseOutline from 'legacy-src/utility/helpers/findResourceInCourseOutline';
import ShareWrapper from 'chameleon/packages/units/components/ShareWrapper';
import React from 'react';
import { compose } from 'react-apollo';
import { withRouter } from 'react-router';
import { withCourseOutline } from 'chameleon-packages/units';
import { withRedux } from 'chameleon/legacy/src/components/assessment/Results/RelatedData/RelatedVideos/wrappers/';

const ShareResourcePDFAction = ({
  courseOutline,
  assessment,
  chosenEducationPeriodCode,
  stopPropagation,
  closePopUp,
}) => (
  <ShareWrapper
    resource={
      findResourceInCourseOutline(assessment.id, courseOutline.units).resource
    }
    text="Share resource"
    educationPeriod={chosenEducationPeriodCode}
    unitNumber={assessment.unit_id}
    id={assessment.id}
    onClose={stopPropagation(closePopUp)}
  />
);

export default compose(
  withRouter,
  withRedux,
  withCourseOutline(),
)(ShareResourcePDFAction);
